import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// Interfaces
import { ICourse } from 'store/StateInterfaces';

// Components
import CourseContainer from 'Screens/CoursesList/Student/Containers/CourseContainer';
import CoursesListStudent from '../Components/CoursesListStudent';

// Actions
import * as actions from '../Actions/Actions';

interface IProps {
    coursesMap: Map<number, ICourse>;
    actions: any;
};

class CoursesListStudentPage extends React.Component<IProps, {}> {
    public componentDidMount() {
        if (this.props.coursesMap.size === 0) {
            this.props.actions.loadCoursesListRequest();
        }
    }

    public render() {
        let courses;
        if (this.props.coursesMap.size !== 0) {
            courses = [];
            this.props.coursesMap.forEach((course) => {
                courses.push(<CourseContainer
                    course={course}
                    unRegisterCourse={(courseId) => this.props.actions.unRegisterCourseRequest(courseId)}
                    key={course.id} />);
            });
        }
        if (!courses) {
            courses = <div className='alert alert-danger alert-dismissable bt-alert'>No courses enrolled yet</div>;
        }

        return <CoursesListStudent courses={courses} />
    }
};

interface IReduxState {
    studentCoursesMap: Map<number, ICourse>;
};

const mapStateToProps = (state: IReduxState) => ({
    coursesMap: state.studentCoursesMap
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(actions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CoursesListStudentPage);
